import { AriaAttributes } from 'react';
import { ComponentType, ReactNode } from 'react';
import styled from 'styled-components';

type Props<T extends keyof JSX.IntrinsicElements> = {
  tag?: ComponentType | keyof JSX.IntrinsicElements; // React component, pure html element 둘다 전달 가능
  children?: ReactNode;
} & JSX.IntrinsicElements[T] &
  AriaAttributes;

export function BlueLabelBox<T extends keyof JSX.IntrinsicElements>({
  tag,
  className,
  children,
  ...rest
}: Props<T>) {
  return (
    <BlueLabelBoxContainer className={className} as={tag} {...rest}>
      {children}
    </BlueLabelBoxContainer>
  );
}

const BlueLabelBoxContainer = styled.div`
  position: relative;
  width: 389px;
  min-height: 100px;
  background: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.35s cubic-bezier(0.1, 0.57, 0.1, 1);
  &::before {
    content: '';
    height: 8px;
    background: #2564ce;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  @media (hover: hover) {
    &:hover {
      transform: translate3d(0, -10px, 0);
    }
  }
`;
